if (!customElements.get('press-logos')) {
    class PressLogos extends HTMLElement {
        
        constructor() {
            super();
            
            this.mqDesktop = window.matchMedia('(min-width: 750px)');
            this.mqMobile = window.matchMedia('(max-width: 749px)');
            this.selectors = {
                swiper: "swiper-container"
            }
        }
        
        connectedCallback() {
            this.slider = this.querySelector(this.selectors.swiper);
            this.options = this.slider.getAttribute('data-options');
            
            if(!this.slider) {
                return null;
            }
            this.initSlider();
        
        }
        
        initSlider() {
            if (this.swiperInstance) {
                this.swiperInstance.destroy(true, true); 
            }
            const self = this;
            let inlineOptions = this.slider.dataset.options;
            let isNavigationDesktop = false;
            let isNavigationMobile = false;
            
            if(inlineOptions){
                inlineOptions = JSON.parse(inlineOptions);
                isNavigationDesktop = inlineOptions.navigationDesktop;
                isNavigationMobile = inlineOptions.navigationMobile;
                if (inlineOptions.mobileSpaceBetween) {
                    let mobileSpaceBetween = {
                        breakpoints: {
                            750: {
                                spaceBetween: inlineOptions.mobileSpaceBetween
                            }
                        },
                    }
                    Object.assign(inlineOptions, mobileSpaceBetween);
                }
            }
            
            this.swiperParams = {
                freeMode: true,
                watchSlidesProgress: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                on: {
                    init() {
                        this.hostEl.classList.add('swiper-initialized');
                    },
                    resize() {
                        
                        if(this.el){
                            this.el.classList.remove('show-navigation');
                        }
                       
                        if (isNavigationDesktop && self.mqDesktop.matches) {
                            this.el.classList.add('show-navigation');
                        }
                        if (isNavigationMobile && self.mqMobile.matches) {
                            this.el.classList.add('show-navigation');
                        }
                    }
                },
                ...inlineOptions
            };
            
            Object.assign(this.slider, this.swiperParams);
            
            this.slider.initialize();
        }
        
        addListeners() {
            document.addEventListener('shopify:section:reorder', () => this.initSlider());
            document.addEventListener('shopify:section:load',() => this.initSlider());
            document.addEventListener('shopify:section:select', () => this.initSlider());
            document.addEventListener('shopify:section:deselect', () => this.initSlider());
        }

    }
    
    customElements.define('press-logos', PressLogos);
}
document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('press-logos')) {
        const pressLogos = event.target.querySelector('press-logos');
        pressLogos.initSlider();
    }
});